module.exports = __webpack_public_path__ + "static/media/035-luxembourg.8ad5c24b.svg";